module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.name,
    attrs: {
      "id": "layout"
    }
  }, [_c('div', {
    staticClass: "wrapper centered"
  }, [_c('div', {
    staticClass: "main-panel",
    class: {
      'loading': _vm.loading
    }
  }, [_c('div', {
    staticClass: "navless-layout-wrapper"
  }, [_c('div', {
    staticClass: "navless-layout-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _c('span', {
    staticClass: "navless-page-name"
  }, [_c('h2', [_vm._v(_vm._s(_vm.pageName || _vm.description))])]), _c('span', {
    staticClass: "navless-page-close",
    on: {
      "click": _vm.cleanup
    }
  }, [(_vm.$routerHistory.hasHistory()) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.source,
        hash: ""
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')) + "  "), _c('i', {
    staticClass: "fal fa-times-circle"
  })]) : _vm._e()], 1)])]), _c('div', {
    staticClass: "row navless-main-body-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navless-main-body col-md-12"
  }, [_vm._t("default")], 2)])])]), _c('md-footer')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "#/home"
    }
  }, [_c('img', {
    attrs: {
      "src": require("images/../logo-default.svg"),
      "height": "48"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6633a7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/navless.vue
// module id = mDOZ
// module chunks = 13 14